import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/*
 * NOTE: When moving this file, please update "browser" section in package.json
 */
import { BaseRequestPolicy } from "./requestPolicy";
var DisbleResponseDecompressionNotSupportedInBrowser = new Error("DisableResponseDecompressionPolicy is not supported in browser environment");
/**
 * {@link DisableResponseDecompressionPolicy} is not supported in browser and attempting
 * to use it will results in error being thrown.
 */

export function disableResponseDecompressionPolicy() {
  return {
    create: function create(_nextPolicy, _options) {
      throw DisbleResponseDecompressionNotSupportedInBrowser;
    }
  };
}
export var DisableResponseDecompressionPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(DisableResponseDecompressionPolicy, _BaseRequestPolicy);

  var _super = _createSuper(DisableResponseDecompressionPolicy);

  function DisableResponseDecompressionPolicy(nextPolicy, options) {
    var _this;

    _classCallCheck(this, DisableResponseDecompressionPolicy);

    _this = _super.call(this, nextPolicy, options);
    throw DisbleResponseDecompressionNotSupportedInBrowser;
    return _this;
  }

  _createClass(DisableResponseDecompressionPolicy, [{
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_request) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw DisbleResponseDecompressionNotSupportedInBrowser;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sendRequest(_x) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  }]);

  return DisableResponseDecompressionPolicy;
}(BaseRequestPolicy);